import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { FileText, ClipboardList, ChevronDown, Check, Loader2, Images } from "lucide-react";

interface PDFExportButtonProps {
  isPdfExportEnabled: boolean;
  isPdfExportVerboseEnabled: boolean;
  isPdfLoading: boolean;
  handlePDFExport: (isSOW: boolean) => void;
  hasPdfExport: boolean;
  isPhotoReportEnabled: boolean;
  onPhotoReportExport: () => void;
}

export const PDFExportButton = ({
  isPdfExportEnabled,
  isPdfExportVerboseEnabled,
  isPdfLoading,
  handlePDFExport,
  hasPdfExport,
  isPhotoReportEnabled,
  onPhotoReportExport,
}: PDFExportButtonProps) => {
  if (!isPdfExportEnabled) {
    return null;
  }

  const loadingIcon = isPdfLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : null;

  return (
    <TooltipProvider>
      <DropdownMenu>
        {hasPdfExport ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex">
                <DropdownMenuTrigger asChild>
                  <Button variant="accent" className="relative" disabled={isPdfLoading}>
                    {loadingIcon}
                    <p>Export to PDF</p>
                    <ChevronDown className="ml-2 h-4 w-4" />
                    <span className="absolute -top-2 -right-2 flex items-center justify-center rounded-full bg-emerald-500 p-[2px] shadow-lg">
                      <Check size={8} className="text-white" />
                    </span>
                  </Button>
                </DropdownMenuTrigger>
              </span>
            </TooltipTrigger>
            <TooltipContent className="bg-background text-foreground">Previously exported to PDF</TooltipContent>
          </Tooltip>
        ) : (
          <DropdownMenuTrigger asChild>
            <Button variant="accent" disabled={isPdfLoading}>
              {loadingIcon}
              <p>Export to PDF</p>
              <ChevronDown className="ml-2 h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
        )}
        <DropdownMenuContent align="end">
          {isPdfExportVerboseEnabled ? (
            <>
              <DropdownMenuItem onClick={() => handlePDFExport(false)}>
                <FileText className="mr-2 h-4 w-4" />
                <span>Summarized</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handlePDFExport(true)}>
                <ClipboardList className="mr-2 h-4 w-4" />
                <span>Itemized</span>
              </DropdownMenuItem>
            </>
          ) : (
            <DropdownMenuItem onClick={() => handlePDFExport(false)}>
              <FileText className="mr-2 h-4 w-4" />
              <span>Export to PDF</span>
            </DropdownMenuItem>
          )}
          {isPhotoReportEnabled && (
            <DropdownMenuItem onClick={onPhotoReportExport}>
              <Images className="mr-2 h-4 w-4" />
              <span>Photo Report</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </TooltipProvider>
  );
};
